import * as React from 'react';

import type { InstructorManageInstructorsPanelProps } from './InstructorManageInstructorsPanel.types';

import { ManageInstructorsPanelShell } from './components/manage-instructors-panel-shell/ManageInstructorsPanelShell';

const InstructorManageInstructorsPanel = React.memo(
  ({
    onClose,
  }: Readonly<InstructorManageInstructorsPanelProps>): React.ReactElement => (
    <ManageInstructorsPanelShell onClose={onClose} />
  )
);

InstructorManageInstructorsPanel.displayName =
  'InstructorManageInstructorsPanel';
export { InstructorManageInstructorsPanel };
